type Props = {
  size?: number
  className?: string
}

const PremiumFeaturesIcon = ({ size = 20, className = "" }: Props) => (
  <span
    className={`inline-block shrink-0 rounded-[3px] bg-gradient-to-br from-amber-200 via-amber-400 to-orange-600 ${className}`}
    style={{
      width: size / Math.SQRT2,
      height: size / Math.SQRT2,
      transform: "rotate(45deg)"
    }}
    aria-hidden="true"
  />
)

export default PremiumFeaturesIcon
